/**
 * AI 生成历史 — 基于 localStorage，按客户 + 商品维度存储。
 */
(function () {
  "use strict";

  const STORAGE_PREFIX = "mogcustom_ai_gen_history";
  const MAX_ENTRIES_PER_PRODUCT = 40;

  function getCustomerId() {
    const key =
      window.AI_UPLOAD_CONFIG?.customerIdStorageKey || "mogcustom_customer_id";
    let id = localStorage.getItem(key);
    if (!id) {
      id =
        "guest-" +
        (typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2));
      localStorage.setItem(key, id);
    }
    return id;
  }

  function storageKey(productId) {
    return `${STORAGE_PREFIX}_${getCustomerId()}_${productId}`;
  }

  function readEntries(productId) {
    if (!productId) return [];
    try {
      const raw = localStorage.getItem(storageKey(productId));
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function writeEntries(productId, entries) {
    if (!productId) return;
    try {
      localStorage.setItem(storageKey(productId), JSON.stringify(entries));
    } catch (e) {
      console.warn("[AiGenerationHistory] localStorage write failed", e);
    }
  }

  function getProductIdFromSection(root) {
    const script = root?.querySelector(".product-generation-config");
    if (!script) return null;
    try {
      const data = JSON.parse(script.textContent);
      return data.productId ? String(data.productId) : null;
    } catch {
      return null;
    }
  }

  window.AiGenerationHistory = {
    getCustomerId,
    getProductIdFromSection,

    add(url, productId, context) {
      if (!url || !productId) return;
      const entries = readEntries(productId);
      const filtered = entries.filter((e) => e.url !== url);
      const userImageUrls = Array.isArray(context?.userImageUrls)
        ? context.userImageUrls.filter(Boolean)
        : [];
      filtered.unshift({
        url,
        productId: String(productId),
        timestamp: Date.now(),
        variantId: context?.variantId ? String(context.variantId) : "",
        variantTitle: context?.variantTitle || "",
        variantOptions: Array.isArray(context?.variantOptions)
          ? context.variantOptions
          : [],
        customProperties:
          context?.customProperties &&
          typeof context.customProperties === "object"
            ? context.customProperties
            : {},
        userImageUrls,
        taskId: context?.taskId ? String(context.taskId) : "",
      });
      writeEntries(productId, filtered.slice(0, MAX_ENTRIES_PER_PRODUCT));
    },

    getForProduct(productId) {
      return readEntries(productId);
    },

    remove(url, productId) {
      if (!url || !productId) return;
      const entries = readEntries(productId).filter((e) => e.url !== url);
      writeEntries(productId, entries);
    },
  };
})();
